import React from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { HeadMedium, HeadWrap, PillButtonEdit, EditIcon } from "../../styles";
import editIcon from "../../../../../../assets/icons/edit.svg";
import { SubHeadTitle, ImageWrap, ValueStyle } from "../Details/styles";
import {
  step2Edit,
  jsonfinal,
  validateSubmit,
  closeModalAPIFail,
  resetFormData,
  showOaaSubmitLoader
} from "../../../actions";
import {
  AccountNameWrap,
  TitleTopSpace,
  DisplayFlex,
  GhostButtonWrap
} from "./styles";
import LegacyAccordions from "../LegacyAccordions/LegacyAccordions";
import { UnderLine } from "../../../Step2LegacyOptions/Components/LegacyOptions/styles";
import GiveIcon from "../../../../../../assets/icons/give.svg";
import { DividerWrap } from "../Details/styles";
import { Divider } from "antd";
import { PrimaryButtonComponentNext, ButtonWrapper } from "../../../Step1Setup/styles";
import Popup from "../../../Step1Setup/Components/Popup/Popup";
import history from "../../../../../../history/history";
import moment from "moment";
import { updateStepperIndex, updateStepperAllToFinish, resetStepperIndex } from "../../../../../../actions/globalActions";
import { AlertPopUpPrimary } from "../../../Step1Setup/styles";
import { getpwUrl, initiateTracking, recordError } from "../../../../../../utils/commonUtil";
import { withContents } from "../../../../../../CommonComponents/ContentMessages";
import { getAlert, mapContents } from "../../../Step1Setup/Components/UtilFunctions";
import * as CustomPropTypes from '../../../DefaultPropTypes';
import { GeneralButton, CapsuleButton } from "../../../../../../CommonComponents/Commons/commonComponents";
import { Spinner } from '../../../../../../CommonComponents/commonStyles';

export class LegacyOptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      type: "exit",
      apiStatus: this.props.apiStatus,      
      stepper : [
        {
          key: 1,
          description: "Provide account information",
          status: "",
          route: "/open-an-additional-account/account-information/",
          pageName: "step1Setup"
        },
        {
          key: 2,
          description: "Legacy options",
          status: "",
          route: "/open-an-additional-account/legacy-options/",
          pageName: "step2Legacy"
        },
        {
          key: 3,
          description: "Review and Submit",
          status: "",
          route: "/open-an-additional-account/review/",
          pageName: "step3Review"
        }
      ],
      exitPopupContent: {
        heading: "Exit",
        line1:
          "Exiting will discard all information in the flow. You will have to start the process again",
        line2: "Do you want to continue?",
        continue: "continue",
        cancel: "No, take me back",
        type: "exit"
      },
      alertStatus: false
    };

    this.bestowToOthers = false;
    this.endowToCharity = false;

  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.apiStatus == true) {
      history.push("/open-an-additional-account/confirm/");
    }    
  }
  handleEdit = () => {
    try {
      initiateTracking('edit', 'Open Additional Account', 'Step 3 Review and Submit - Legacy Options', 'Edit - Body');
      this.props.updateStepperIndex({
        status: true,
        index: 1
      });
      let stepperConfig = [...this.state.stepper];
      stepperConfig[0].status = "finish";
      stepperConfig[1].status = "process";
      stepperConfig[2].status = "wait";
  
      this.props.updateStepperAllToFinish(stepperConfig);
  
      history.push("/open-an-additional-account/legacy-options/");
      window.scrollTo(0, 0);
    } catch (error) {
      recordError(error);
    }
  };
  getAccordionHeading = () => {
    this.props.tempData.tempJSON.legacyOptions.forEach(val => {
      if (parseInt(val.percentage) > 0) {
        if (val.optionId == 1 || val.optionId == 2) {
          this.bestowToOthers = true;
        } else {
          this.endowToCharity = true;
        }
      }
    });
  };

  closeModal = () => {
    this.setState({
      show: false
    });
  };

  handleExitClick = () => {
    initiateTracking('exit','Open Additional Account', 'Step 3 Review and Submit', 'Exit');

    this.setState({
      show: !this.state.show
    });

    this.props.resetFormData();
    this.props.resetStepperIndex();
    history.push("/");
    window.scrollTo(0, 0);
  };

  modifyPhoneFormat = type => {
    let phone;
    if (type == "primary") {
      phone = this.props.tempData.tempJSON.advisors[0].phones;
    } else {
        phone = this.props.tempData.tempJSON.advisors[1].phones;
    }
    let newPhoneFormat = [];
    phone.forEach((val, index) => {
      let tempObj = {
        phoneNumber: val.phonenumber.trim(),
        phoneType: val.phonetype
      };
      newPhoneFormat.push(tempObj);
    });
    return newPhoneFormat;
  };

  modifyEmailFormat = type => {
    let email;
    if (type == "primary") {
      email = this.props.tempData.tempJSON.advisors[0].emails;
    } else {
        email = this.props.tempData.tempJSON.advisors[1].emails;
     
    }
    let newEmailFormat = [];
    email.forEach((val, index) => {
      let tempObj = {
        emailId: val.emailId,
        emailType: val.emailtype
      };
      newEmailFormat.push(tempObj);
    });
    return newEmailFormat;
  };

  modifyAddressFormat = type => {
    let address;
    let removedAddrs;
    let deletedAddress;
    const {countries = [], states = []} = this.props.dropDown;
    if (type == "primary") {
      address = this.props.tempData.tempJSON.advisors[0].addresses;
      removedAddrs = this.props.tempData.tempJSON.advisors[0].remAddressPA;
      if(removedAddrs){
      deletedAddress = removedAddrs.filter((elm)=>{return !(address.some((val)=>{
        return val.addresstype == elm.addressType
      }))});
      }
    } else {
        address = this.props.tempData.tempJSON.advisors[1].addresses;
    }
    let newAddressFormat = [];
    address.forEach((val, index) => {
      let countrydesc = countries.find((cntr)=>{
        return  cntr.value === val.country
      })

      let statedesc = states.find((cntr)=>{
        return  cntr.value === val.state
      })
      let tempObj = {
        addressId: type == "primary" ? val.addressId : val.key,
        primary: val.primary,
        addressType: val.addresstype,
        addressLine1: val.line1,
        addressLine2: val.line2,
        addressLine3: val.line3,
        city: val.city,
        state: statedesc ? statedesc?.desc : val.state,
        zipCode: val.zipcode,
        country: countrydesc?.desc,
        addressUpdated: address.addressChange ? true : false
      };
      newAddressFormat.push(tempObj);
    });
    if(deletedAddress){
    newAddressFormat = [...newAddressFormat,...deletedAddress];
    }
    return newAddressFormat;
  };

  getPartyIdAndRole = (type, advisor = '') => {
    if (type == "partyId") {
      return JSON.parse(sessionStorage.getItem("userData")).partyId;
    } else {
      let roleModifiedObj = {
        roleId: 0,
        roleType: "Account Advisor - Full Access",
        roleTypeId: 1,
        name: null,
        primary: advisor,
        primaryAdvisor: advisor
      };
      return roleModifiedObj;
    }
  };
  verifyGrantData = grant => {
    let grantData = [];
    const {countries = [], states = []} = this.props.dropDown;
    if(grant[0].name){
    grantData = grant.map((val, index) => {
      delete val.charityNameError;
      delete val.phoneError;
      delete val.line1Error;
      delete val.cityError;
      delete val.zipError;
      delete val.stateError;
      delete val.countryError;
      delete val.address.line1Error;
      delete val.address.zipError;
      delete val.address.cityError;
      delete val.address.stateError;
      delete val.address.countryError;
      delete val.charityAllocPercentError;
      delete val.multipleCharitiesError;
      delete val.grantRecognitionError;
      delete val.otherGrantPurposeTextError;
      delete val.address.zipTitle;
      delete val.emailError;
      delete val.key;

      let tempObj = Object.assign({}, val);
      tempObj.grantPurpose = tempObj.grantPurpose === 'AOMN' ? 'Area of most need' : 'Other';
      let countrydesc = countries.find((cntr)=>{
        return  cntr.value === tempObj.address.country
      })
      tempObj.address.country = countrydesc?.desc;
      let statedesc = states.find((cntr)=>{
        return  cntr.value === tempObj.address.state
      })
      tempObj.address.state = statedesc ? statedesc?.desc : tempObj.address.state
      return tempObj;
    });
  }
    return grantData;
  };

  filterDropDownDataWithValue(value, dropdown, field) {
    if (value != "" && dropdown && dropdown.length != 0) {
      let desc = dropdown.filter(val => {
        return val.desc == value;
      });
      if (desc != undefined) {
        return desc[0];
      } else {
        return null;
      }
    }
  }

  verifySuccessorData = successor => {
    const {countries = [], states = []} = this.props.dropDown;
    let successorData = [];
    if(successor[0].firstName){
    successorData = successor.map((val, index) => {
      delete val.key;
      delete val.gender;
      delete val.relationshipTypeError;
      delete val.firstNameError;
      delete val.lastNameError;
      delete val.dobError;
      delete val.genderError;
      delete val.preferedPhoneError;
      delete val.preferedEmailError;
      delete val.address.line1Error;
      delete val.address.zipError;
      delete val.address.cityError;
      delete val.address.stateError;
      delete val.address.countryError;
      delete val.address.zipTitle;
      delete val.duplicateError;
      
      let tempObj = Object.assign({}, val);
      let countrydesc = countries.find((cntr)=>{
        return  cntr.value === tempObj.address.country
      })
      tempObj.address.country = countrydesc?.desc;
      let statedesc = states.find((cntr)=>{
        return  cntr.value === tempObj.address.state
      })
      tempObj.address.state = statedesc ? statedesc?.desc : tempObj.address.state;
      let dobVal =  moment(val.dob).format("YYYY-MM-DD");
      tempObj.dob = moment(new Date(dobVal)).toDate().getTime();
      tempObj.dobStr = moment(val.dob).format("MM/DD/YYYY");
      tempObj.relationshipType = tempObj.relationshipType
        ? this.filterDropDownDataWithValue(
            val.relationshipType,
            this.props.relationshipValuesNew
          ).value
        : null;
      return tempObj;
    });
  }
    return successorData;
  };
  createPlanModels = () => {
    let planModels = [];
    let legacyOption = this.props.legacyOptions ? this.props.legacyOptions: [];
    for (let i = 0; i < legacyOption.length; i++) {
         let tempObj = {
            optionName: legacyOption[i].optionName,
            optionId: legacyOption[i].optionId,
            assignedPercentage: legacyOption[i].percentage ? legacyOption[i].percentage : '',
            selected: legacyOption[i].percentage ? true : false,
            successorAdvisor:
              legacyOption[i].optionId == 1 || legacyOption[i].optionId == 2
                ? this.verifySuccessorData(
                    legacyOption[i].successorAdvisor.successorAdvisor
                  )
                : [],
            successionPlanGranteeOrg:
              legacyOption[i].optionId == 4
                ? this.verifyGrantData(
                    legacyOption[i].successorAdvisor.successorAdvisor
                  )
                : []
          };
        planModels.push(tempObj);
    }
    return planModels;
  };

  checkforNullOrUndefined(){
    if(this.props.tempData.tempJSON.advisors[1].firstname != null && this.props.tempData.tempJSON.advisors[1].firstname != ""){
      return true;  
    }
    return false;
  }

  getAdvisorData = () => {
    const {title: titles = [], suffix: suffixs = [] } = this.props.dropDown;
    let {
      title,
      firstname,
      middlename,
      lastname,
      suffix,
      gender,
      dob,
      ssn,
      deliveryMethod
    } = this.props.tempData.tempJSON.advisors[0];

    let titledesc = titles.find((cntr)=>{
      return  cntr.value === title
    })

    let suffixdesc = suffixs.find((cntr)=>{
      return  cntr.value === suffix
    })

    let dobPriVal =  moment(dob).format("YYYY-MM-DD");

    let advisorData = [
      {
        primary: true,
        title: titledesc?.desc === '--' ? null : titledesc?.desc,
        firstName: firstname,
        middleName: middlename,
        lastName: lastname,
        suffix: (suffixdesc?.desc === '--' || suffixdesc?.desc === undefined) ? null : suffixdesc?.desc,
        gender: gender,
        dob: moment(new Date(dobPriVal)).toDate().getTime(),
        ssn: ssn,
        phones: this.modifyPhoneFormat("primary"),
        emails: this.modifyEmailFormat("primary"),
        addresses: this.modifyAddressFormat("primary"),
        deliveryMethod: deliveryMethod,
        partyId: this.getPartyIdAndRole("partyId"),
        preferredContactMethod: null,
        referralValue: null,
        referralComments: null,
        role: this.getPartyIdAndRole("roleDetails",true),
        dobStr: moment(dob).format("MM/DD/YYYY")
      }
    ];
    if ( this.props.tempData.tempJSON.advisors[1] && this.checkforNullOrUndefined()  ) {
      let {
        title,
        firstname,
        middlename,
        lastname,
        suffix,
        gender,
        dob,
        ssn,
        deliveryMethod
      } = this.props.tempData.tempJSON.advisors[1];

      let titledesc = titles.find((cntr)=>{
        return  cntr.value === title
      })
  
      let suffixdesc = suffixs.find((cntr)=>{
        return  cntr.value === suffix
      })
      
      let dobSecVal =  moment(dob).format("YYYY-MM-DD");

      advisorData.push({
        primary: false,
        title: titledesc?.desc === '--' ? null : titledesc?.desc,
        firstName: firstname,
        middleName: middlename,
        lastName: lastname,
        suffix: (suffixdesc?.desc === '--' || suffixdesc?.desc === undefined) ? null : suffixdesc?.desc,
        gender: gender,
        dob: moment(new Date(dobSecVal)).toDate().getTime(),
        ssn: ssn,
        phones: this.modifyPhoneFormat("secondary"),
        emails: this.modifyEmailFormat("secondary"),
        addresses: this.modifyAddressFormat("secondary"),
        deliveryMethod: deliveryMethod,
        partyId: 0,
        preferredContactMethod: null,
        referralValue: null,
        referralComments: null,
        role: this.getPartyIdAndRole("roleDetails",false),
        dobStr: moment(dob).format("MM/DD/YYYY")
      });
    }
    return advisorData;
  };

  getPostData = () => {
    let postData = {
      existingUser: true,
      accountName: this.props.fundName,
      ssn: this.props.tempData.tempJSON.advisors[0].ssn,
      advisors: this.getAdvisorData(),
      planModels: this.createPlanModels()
    };

    return postData;
  };

  handleNext = () => {
    this.props.showOaaSubmitLoader();
    let jsonPostData = this.getPostData();
    this.props.jsonfinal({
      finalJSON: jsonPostData
    });
    this.props.validateSubmit({
      method: "POST",
      url: "/DP/FinancialAccount/OAA",
      data: jsonPostData,
      isBhoomiUrl:true
    });    
  };

  hideModal = () => {
    this.props.closeModalAPIFail();
  };

  viewEndowedGrantPlanPdf = () => {
    try {
      initiateTracking('download','Open Additional Account', 'Step 3 Review and Submit - Grant Annually', 'Endowed Grant Plan Form PDF');
      window.open(`${getpwUrl()}` + "/sites/default/files/2019-05/EndowedGrantForm.pdf", '_blank');
    } catch (error) {
      recordError(error);
    }
  }

  render() {
    this.getAccordionHeading();
    const { alertOOA } = this.props;
    const { alertStatus, exitPopupContent } = this.state;
    
    if(alertOOA && alertOOA.length && !alertStatus){
      this.setState({
        exitPopupContent: mapContents(getAlert(alertOOA,'Exit'), exitPopupContent),
        alertStatus: true
      })
    }
    return (
      <div>
        {this.state.show ? (
          <Popup
            height="313px"
            width="481px"
            mwidth="88%"
            mheight="53%"
            content={exitPopupContent}
            closeModal={this.closeModal}
            handleExitClick={() => this.handleExitClick()}
          />
        ) : null}
        <div>
          <HeadWrap>
            <HeadMedium>Legacy Options</HeadMedium>
            <CapsuleButton
              whiteBackground = {true}
              text = "Edit"
              iconType = "edit"
              onClick={this.handleEdit}
            />
          </HeadWrap>
        </div>
        <AccountNameWrap>
          <SubHeadTitle>
            <ImageWrap marginRight="9px" src={GiveIcon}  alt="Give" />
            Philanthropic account name
          </SubHeadTitle>
          <ValueStyle marginLeft="27px" lineHeight="1.5">{`The ${
            this.props.tempData.tempJSON.fundName
          } Fund`}</ValueStyle>
        </AccountNameWrap>
        {this.bestowToOthers ? (
          <div>
            <SubHeadTitle>Bestow to others</SubHeadTitle>
            {this.props.tempData.tempJSON.legacyOptions.map(val => {
              if (val.optionId < 3) {
                if (parseInt(val.percentage) > 0) {
                  let subTitle = "";
                  if (val.optionId == 1) {
                    subTitle =
                      "Assign a percentage of the remaining account assets to the following successor advisor(s).";
                  } else {
                    subTitle =
                      "Create new charitable giving account(s) for named successor advisor(s).";
                  }
                  return (
                    <LegacyAccordions
                      subTitle={(this.props.contents && this.props.contents[`field_type_${val.optionId}_description`]) || subTitle}
                      title={(this.props.contents && this.props.contents[`field_type_${val.optionId}_title`]) || val.optionName}
                      contentKey={val.optionId}
                      percentage={val.percentage}
                    />
                  );
                }
              } else {
                return false;
              }
            })}
          </div>
        ) : null}
        {this.endowToCharity ? (
          <div>
            {this.bestowToOthers ? (
              <TitleTopSpace paddingTop="10px">
                <SubHeadTitle>Endow to charity</SubHeadTitle>
              </TitleTopSpace>
            ) : (
              <TitleTopSpace paddingTop="0">
                <SubHeadTitle>Endow to charity</SubHeadTitle>
              </TitleTopSpace>
            )}

            {this.props.tempData.tempJSON.legacyOptions.map(val => {
              if (val.optionId > 2) {
                if (parseInt(val.percentage) > 0) {
                  let subTitle = "";
                  if (val.optionId == 3) {
                    subTitle =
                      "Transfer the account's remaining assets to Vanguard Charitable's Philanthropic Impact Fund. This mission-driven fund supports charities that encourage charitable giving and philanthropy.";
                  } else if (val.optionId == 4) {
                    subTitle =
                      "Recommend grants to public charities, of your choice, in equal amounts.";
                  } else {
                    subTitle = (
                      <div>
                        Recommend an Endowed Grant Plan. See our{" "}
                        <a
                          href={
                            `${getpwUrl()}` +
                            "/company-policies/policies-and-guidelines"
                          }
                          target="_blank"
                        >
                          <UnderLine>Policies and guidelines</UnderLine>
                        </a>{" "}
                        and complete a Recommend an{" "}
                        <a
                          onClick={() => this.viewEndowedGrantPlanPdf()}
                          target="_blank"
                        >
                          <UnderLine>Endowed Grant Plan form</UnderLine>
                        </a>
                        .
                      </div>
                    );
                  }
                  return (
                    <LegacyAccordions
                      subTitle={(this.props.contents && this.props.contents[`field_type_${val.optionId}_description`]) || subTitle}
                      title={(this.props.contents && this.props.contents[`field_type_${val.optionId}_title`]) || val.optionName}
                      contentKey={val.optionId}
                      percentage={val.percentage}
                    />
                  );
                }
              }
            })}
          </div>
        ) : null}
        <DividerWrap paddingTop="10px" paddingBottom="30px">
          <Divider />
        </DividerWrap>

        <DisplayFlex>
          <ButtonWrapper marginTop={true}>
            <GeneralButton 
              width = "150px"
              mobWidth = "100%"
              text = "EXIT"
              type = "functional"
              inverted = {true}
              onClick={() =>
                this.setState({
                  show: true,
                  type: "exit"
                })
              }
            />
          </ButtonWrapper>

          <ButtonWrapper marginTop={true}>
            {
              this.props.apiIndicator
              ? (
                <GeneralButton
                  id="btnSubmitLoader"
                  type="functional"
                  text={<Spinner />}
                  width="150px"
                  mobWidth = "100%"                
                />)
              : (
                <GeneralButton
                  id="btnOAASubmit"
                  text = "SUBMIT"
                  width = "150px"
                  mobWidth = "100%"
                  onClick={this.handleNext}
                />
              )
            }
          </ButtonWrapper>
        </DisplayFlex>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fundName: state.getIn(["npaFormReducer", "fundName", "fundName", "fundName"]),
  legacy: state.getIn([
    "npaFormReducer",
    "legacyOptions",
    "legacyOptions",
    "legacyOptions"
  ]),
  webAccessInfo: state.getIn(["npaFormReducer", "webAccessInfo"]).toJS(),
  legacyOptions: state.getIn([
    "npaFormReducer",
    "legacyOptions",
    "legacyOptions",
    "legacyOptions"
  ]),
  tempData: state.getIn(["npaFormReducer", "tempJSON", "tempJSON"]),
  apiStatus: state.getIn(["npaFormReducer", "apiStatus"]),
  apiIndicator: state.getIn(["npaFormReducer", "apiIndicator"]),
  dropDown: state.getIn(["npaFormReducer", "dropdownValues", "data"]),
  alertOOA: state.getIn(['npaFormReducer','alerts']),
  relationshipValuesNew: state.getIn(['npaFormReducer','relationshipValuesNew'])
});

export const mapDispatchToProps = dispatch => ({
  step2Edit: val => dispatch(step2Edit(val)),
  jsonfinal: val => dispatch(jsonfinal(val)),
  validateSubmit: val => dispatch(validateSubmit(val)),
  updateStepperIndex: data => dispatch(updateStepperIndex(data)),
  closeModalAPIFail: data => dispatch(closeModalAPIFail(data)),
  updateStepperAllToFinish: data => dispatch(updateStepperAllToFinish(data)),
  resetFormData: () => dispatch(resetFormData()),
  resetStepperIndex: () => dispatch(resetStepperIndex()),
  showOaaSubmitLoader: () => dispatch(showOaaSubmitLoader())
});

LegacyOptions.propTypes = {
  alertOOA: CustomPropTypes.basicAlertContents,
  apiStatus: PropTypes.string,
  closeModalAPIFail: PropTypes.func,
  contentType: PropTypes.string,
  contents: PropTypes.object,
  dropDown: CustomPropTypes.basicDropDownShape,
  fundName: PropTypes.string,
  jsonfinal: PropTypes.func,
  legacy: CustomPropTypes.basicLegacy,
  legacyOptions: CustomPropTypes.basicLegacy,
  page: PropTypes.string,
  resetFormData: PropTypes.func,
  resetStepperIndex: PropTypes.func,
  step2Edit: PropTypes.func,
  tempData: CustomPropTypes.basicTempData,
  updateStepperAllToFinish: PropTypes.func,
  updateStepperIndex: PropTypes.func,
  validateSubmit: PropTypes.func,
  webAccessInfo: CustomPropTypes.basicWebAccessInfo
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withContents(LegacyOptions));
